import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "categoryEmergencyTypes",
    "category_emergency_type",
    "EmergencyForm",
    "/emergency-types",
);

export default handleActions(reducers, initialState);
